import React, { useState } from "react"
import { FaSearch, FaBars } from "react-icons/fa"
import { Link } from "gatsby"
import {
  wrapper,
  stickyNav,
  desktopNav,
  mkbsdMenu,
  mkbsdMenuName,
  logoWrapper,
  logo,
  searchIcon,
  menuIcon,
  mobileNav,
  searchBox,
  quickNav,
  quickNavLink,
  quickNavLinkActive,
  quickNavItem,
  quickNavItemLabel,
} from "./sticky-nav.module.css"
import Sidebar from "../sidebar/sidebar"
import DesktopNav from "../desktop-nav/desktop-nav"
import logoMkbsd from "../../images/mkbsd-logo-20-jaar.svg"
import SearchBox from "../search-box/search-box"
import { trackEvent } from "../../modules/analytics"
import ParticleContainer from "../particle-container/particle-container"
import iconKennis from "../../images/graduation-cap.svg"

const StickyNav = ({ desks }) => {
  if (desks && desks.nodes) desks = desks.nodes
  const [menuActive, toggleMenu] = useState(false)
  const [isActive, setIsActive] = useState(false)

  const toggle = (state) => {
    if (state) trackEvent("nav_mobilemenu_open")
    toggleMenu(state)
    state
      ? document.body.classList.add("sidebar-open")
      : document.body.classList.remove("sidebar-open")
  }

  return (
    <>
      <Sidebar
        isActive={menuActive}
        toggleMenu={toggle}
        desks={[...desks]}
      ></Sidebar>
      <div className={wrapper}>
        <div className={quickNav}>
          <a
            className={quickNavLink}
            href="https://mediakit.mkbservicedesk.nl/"
            activeClassName={quickNavLinkActive}
            rel="nofollow noreferrer"
            target="_blank"
            onClick={() => trackEvent("topnav_mediakit")}
          >
            <div className={quickNavItem}>
              <span className={quickNavItemLabel}>partner worden?</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.2193 4.04346V5.24158H13.2194L2.76652 8.45463H0V14.8421H2.76652L4.20989 15.2858V17.9949L10.5921 19.9567V17.2476L13.2193 18.0551V19.2533H18.0926V4.04346H13.2193ZM2.40966 13.2768H1.5652V10.0198H2.40966V13.2768ZM9.02695 17.8381L5.77514 16.8385V15.7669L9.02695 16.7665V17.8381ZM13.2194 16.4176L3.97486 13.576V9.72068L13.2194 6.87902V16.4176ZM16.5275 17.6881H14.7846V5.60866H16.5275V17.6881Z"
                  fill="black"
                />
                <path
                  d="M24 10.8657H20.5779V12.4309H24V10.8657Z"
                  fill="black"
                />
                <path
                  d="M20.3898 13.0121L19.4697 14.2783L22.2382 16.2898L23.1582 15.0236L20.3898 13.0121Z"
                  fill="black"
                />
                <path
                  d="M22.2385 7.00658L19.4701 9.01807L20.3901 10.2843L23.1586 8.27283L22.2385 7.00658Z"
                  fill="black"
                />
              </svg>
            </div>
          </a>
          <Link
            className={quickNavLink}
            to={"/kennissessies"}
            activeClassName={quickNavLinkActive}
            onClick={() => trackEvent("topnav_kennissessies")}
          >
            <div className={quickNavItem}>
              <span className={quickNavItemLabel}>kennissessies</span>
              <img src={iconKennis} style={{ height: "24px"}} alt="graduation cap" />
              </div>
          </Link>
          <Link
            className={quickNavLink}
            to={"/producten"}
            activeClassName={quickNavLinkActive}
            onClick={() => trackEvent("topnav_products")}
          >
            <div className={quickNavItem}>
              <span className={quickNavItemLabel}>producten</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2563_1617)">
                  <path
                    d="M20.4025 1.38764H17.0989V0H6.90105V1.38768H3.59749L1.90156 8.45005H0.000732422V14.0868H1.82454L3.79741 24H20.2026L22.1754 14.0868H23.9992V8.45H22.0984L20.4025 1.38764ZM8.46615 1.56511H15.5338V2.77532H8.46615V1.56511ZM4.83124 2.95279H6.90105V4.34043H17.0989V2.95279H19.1687L20.4888 8.45H3.51119L4.83124 2.95279ZM18.9183 22.4348H5.08169L3.4204 14.0868H20.5797L18.9183 22.4348ZM22.4342 12.5217H1.56584V10.0152H22.4341L22.4342 12.5217Z"
                    fill="black"
                  />
                  <path
                    d="M7.37048 15.4159L5.83533 15.7214L6.89447 21.0432L8.42962 20.7377L7.37048 15.4159Z"
                    fill="black"
                  />
                  <path
                    d="M16.6295 15.4158L15.5703 20.7375L17.1055 21.0431L18.1646 15.7213L16.6295 15.4158Z"
                    fill="black"
                  />
                  <path
                    d="M12.7824 15.5161H11.2173V20.9414H12.7824V15.5161Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2563_1617">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Link>
          <Link
            className={quickNavLink}
            to={"/nieuws/mkb-servicedesk/over-mkb-servicedesk"}
            activeClassName={quickNavLinkActive}
            onClick={() => trackEvent("topnav_aboutus")}
          >
            <div className={quickNavItem}>
              <span className={quickNavItemLabel}>over ons</span>

              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2563_1632)">
                  <path
                    d="M20.4853 3.51469C18.2188 1.24819 15.2053 0 12 0C8.79469 0 5.78123 1.24819 3.51469 3.51469C1.24819 5.78123 0 8.79469 0 12C0 15.2053 1.24819 18.2188 3.51469 20.4853C5.78123 22.7518 8.79469 24 12 24C15.2053 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51469ZM12 22.4348C6.24628 22.4348 1.5652 17.7538 1.5652 12C1.5652 6.24623 6.24628 1.5652 12 1.5652C17.7537 1.5652 22.4348 6.24628 22.4348 12C22.4348 17.7537 17.7537 22.4348 12 22.4348Z"
                    fill="black"
                  />
                  <path
                    d="M13.2094 6.48267H10.7906V8.67449H13.2094V6.48267Z"
                    fill="black"
                  />
                  <path
                    d="M13.2094 9.5813H10.7906V17.5175H13.2094V9.5813Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2563_1632">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Link>
        </div>
        <div className={stickyNav}>
          <Link
            to="/"
            id="sticky-nav-logo"
            className={logoWrapper}
            onClick={() => trackEvent("nav_logo")}
          >
            <div className={logo}>
              <img
                src={logoMkbsd}
                alt="MKB Servicedesk Logo"
                onClick={() => setIsActive(true)}
              />
            </div>
          </Link>
          <div className={desktopNav}>
            <DesktopNav desks={[...desks]} />
          </div>
          <div className={searchBox}>
            <SearchBox />
          </div>
          <div className={mobileNav}>
            <FaSearch
              className={searchIcon}
              onClick={() => toggle(!menuActive)}
            />
            <button className={mkbsdMenu} onClick={() => toggle(!menuActive)}>
              <span className={mkbsdMenuName}>Menu</span>{" "}
              <FaBars className={menuIcon} />
            </button>
          </div>

          {/* <div className={searchContainer}>
        <form action="/zoeken" id="sticky-nav-search">
          <input
            aria-label="Stel je ondernemersvraag"
            type="text"
            placeholder="Stel je ondernemersvraag"
            name="q"
            className="placeholder-color"
          />
          <button aria-label="Verstuur je zoekopdracht" type="submit">
            <FaSearch />
          </button>
        </form>
      </div> */}

          {/* {desks &&
        <div className={desken}>

          <button type="button" className={deskenButton}><FaFolderOpen />Desken</button>

          <ul id="sticky-nav-desk-links">
            {desks.sort((a, b) => {
              if (a.name < b.name) { return -1; }
              if (a.name > b.name) { return 1; }
              return 0;
            }).map((desk, index) => {
              return <li key={`deskmenu-${index}`}><Link to={linkBuilder.desk(desk)}>{desk.name}</Link></li>
            })}
          </ul>
        </div>
      } */}

          {/* <div className={topnav}>
        <ul id="sticky-nav-links-2">
          <Link to="/nieuws/mkb-servicedesk/over-mkb-servicedesk"><li>Over ons</li></Link>
          <Link to="/nieuws/mkb-servicedesk/contact-mkb-servicedesk"><li>Contact</li></Link>
          <a href="https://mijn.mkbservicedesk.nl" rel="nofollow"><li>Netwerk</li></a>
        </ul>
      </div> */}
        </div>
      </div>

      <ParticleContainer isActive={isActive} setIsActive={setIsActive} />
    </>
  )
}

export default StickyNav
